/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PowChallengeResponseParser = 
/* #__PURE__ */ parsers.object([
    ['nonce', codecString],
    ['difficulty', codecNumber],
]);
export class PowChallengeResponse extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PowChallengeResponseParser.decode(input).map(res => new PowChallengeResponse(res));
    }
    static unsafeDecode(input) {
        return PowChallengeResponse.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PowChallengeResponseParser.encode(data);
    }
    static schema() {
        return PowChallengeResponseParser.schema();
    }
}
